/** Identificador principal del menú (uuid con fallback a id). */
export function menuKey(menu: any): string {
    return String(menu?.uuid ?? menu?.id ?? '');
}

/** parentId o parentUuid del menú. */
export function menuParentId(menu: any): string | null {
    const raw = menu?.parentUuid ?? menu?.parent_uuid ?? menu?.parentId ?? menu?.parent_id;
    return raw != null && raw !== '' ? String(raw) : null;
}

/** Une el menú del rol con el catálogo para no perder padre ni orden. */
export function mergeMenuCatalog(menu: any, catalogItem: any): any {
    const cat = catalogItem || {};
    return {
        ...cat,
        ...menu,
        uuid: menu?.uuid ?? cat.uuid,
        parentUuid: menu?.parentUuid ?? cat.parentUuid ?? null,
        order: menu?.order ?? cat.order ?? 0,
        name: menu?.name || cat.name,
        availableActions: menu?.availableActions ?? cat.availableActions ?? null
    };
}

/** Árbol plano: raíz y luego hijos, por order. */
export function flattenMenusAsTree(list: any[]): any[] {
    const items = (list || []).map((item) => ({ ...item }));
    const byKey = new Map(items.map((item) => [menuKey(item), item]));
    const kids = new Map<string, any[]>();
    const roots: any[] = [];
    for (const item of items) {
        const pKey = menuParentId(item);
        if (!pKey || !byKey.has(pKey)) {
            roots.push(item);
            continue;
        }
        const bucket = kids.get(pKey) || [];
        bucket.push(item);
        kids.set(pKey, bucket);
    }
    return _flattenLevel(roots, kids, []);
}

/** Si hay un hijo, también van los ancestros del catálogo. */
export function expandMenuIdsWithParents(keys: any[], catalog: any[]): any[] {
    const byKey = new Map((catalog || []).map((m) => [menuKey(m), m]));
    const out = new Set((keys || []).map((k) => String(k)).filter(Boolean));
    for (const key of [...out]) {
        _addAncestors(key, byKey, out);
    }
    return [...out];
}

function _flattenLevel(nodes: any[], kids: Map<string, any[]>, result: any[]): any[] {
    [...nodes]
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        .forEach((node) => {
            result.push(node);
            _flattenLevel(kids.get(menuKey(node)) || [], kids, result);
        });
    return result;
}

function _addAncestors(key: string, byKey: Map<string, any>, out: Set<string>) {
    let pKey = menuParentId(byKey.get(key));
    while (pKey && byKey.has(pKey) && !out.has(pKey)) {
        out.add(pKey);
        pKey = menuParentId(byKey.get(pKey));
    }
}
